var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37946 13.5064C8.07894 13.2179 8.07894 12.7502 8.37946 12.4617C8.67997 12.1732 9.16719 12.1732 9.4677 12.4617L11.2318 14.1553V3.13836C11.2318 2.73073 11.5764 2.3999 12.001 2.3999C12.4256 2.3999 12.7702 2.73073 12.7702 3.13836V14.1553L14.5343 12.4617C14.8348 12.1732 15.322 12.1732 15.6225 12.4617C15.9231 12.7502 15.9231 13.2179 15.6225 13.5064L12.5456 16.4602C12.4749 16.5282 12.3898 16.5823 12.2955 16.6197C12.2011 16.6572 12.1015 16.6768 12.001 16.6768C11.9005 16.6768 11.8011 16.6572 11.7068 16.6197C11.6124 16.5823 11.5272 16.5282 11.4564 16.4602L8.37946 13.5064ZM18.1538 9.29221C17.7292 9.29221 17.3846 9.62304 17.3846 10.0307C17.3846 10.4383 17.7292 10.7691 18.1538 10.7691C19.7713 10.7691 20.4615 11.4318 20.4615 12.9845V17.9076C20.4615 19.4603 19.7713 20.123 18.1538 20.123H5.84615C4.22872 20.123 3.53846 19.4603 3.53846 17.9076V12.9845C3.53846 11.4318 4.22872 10.7691 5.84615 10.7691C6.27077 10.7691 6.61539 10.4383 6.61539 10.0307C6.61539 9.62304 6.27077 9.29221 5.84615 9.29221C3.36615 9.29221 2 10.6037 2 12.9845V17.9076C2 20.2884 3.36615 21.5999 5.84615 21.5999H18.1538C20.6338 21.5999 22 20.2884 22 17.9076V12.9845C22 10.6037 20.6338 9.29221 18.1538 9.29221Z",
    fill: "#1A1A1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.afb793b3f35f08eb2f1bf825a93d5f18.svg";
export { ForwardRef as ReactComponent };